import { ComponentType, lazy } from 'react';

/** Load a component on demand so it is not parsed and held in memory by
 * everyone. Without this, screens and modals nobody has opened — the rich text
 * editor, the video player, the Stripe and CSV tooling — sit in the single
 * bundle that every member downloads, including one who only plays audio.
 *
 * Components here are named exports rather than defaults, so the named export
 * is mapped onto the default that `lazy` expects. */
export function lazyNamed(
  load: () => Promise<Record<string, ComponentType<any>>>,
  name: string,
) {
  return lazy(async () => {
    const component = (await load())[name];
    /** A mismatched name would otherwise surface as React's "Element type is
     * invalid" when someone happens to open that route. */
    if (!component) {
      throw new Error(`lazyNamed: no export named "${name}" in loaded module`);
    }

    return { default: component };
  });
}
